/* unplugin-vue-components disabled */import { render } from "./qinduqu.vue?vue&type=template&id=47a89c64&scoped=true"
import script from "./qinduqu.vue?vue&type=script&lang=js"
export * from "./qinduqu.vue?vue&type=script&lang=js"

import "./qinduqu.vue?vue&type=style&index=0&id=47a89c64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a89c64"]])

export default __exports__